


















































import { Component, Vue } from 'vue-property-decorator';
import { RecommendationLetter } from '@/models/student/recommendation-letter';
import { DateUtils } from '@/utils/date.utils';
import { recommendationLetterModule } from '@/store/modules/entities/recommendation-letter.module';
import { studentModule } from '@/store/modules/entities/student.module';
import GStudentRecordRecommendationLetterModal from './GStudentRecordRecommendationLetterModal.vue';
import GLoading from '@/components/GLoading.vue';

@Component({
  components: {
    GStudentRecordRecommendationLetterModal,
    GLoading,
  },
})
export default class GStudentRecordRecommendationLetterList extends Vue {
  DateUtils = DateUtils;
  showModal = false;
  selectedLetter: RecommendationLetter | null = null;
  recommendationLetterColumns: any[] = [];
  isLoading = false;

  mounted() {
    this.recommendationLetterColumns = [
      {
        title: this.$t('RECOMMENDATION_LETTERS_TITLE'),
        slot: 'title',
        align: 'center',
      },
      {
        title: this.$t('RECOMMENDATION_LETTERS_TARGET_INSTITUTION_NAME'),
        slot: 'targetInstitution',
        align: 'center',
      },
      {
        title: this.$t('RECOMMENDATION_LETTERS_TARGET_POLICY'),
        slot: 'generationPolicy',
        align: 'center',
      },
      {
        title: this.$t('LAST_UPDATED_USER_NAME'),
        slot: 'lastUpdateUserName',
        align: 'center',
      },
      {
        title: this.$t('LAST_UPDATED_AT'),
        slot: 'updatedAt',
        align: 'center',
      },
      {
        title: this.$t('OPERATE'),
        slot: 'action',
        align: 'center',
      },
    ];
    // 初期表示時にローディングを表示
    this.fetchRecommendationLetters();
  }

  get letters(): RecommendationLetter[] {
    return studentModule.recommendationLetters;
  }

  async fetchRecommendationLetters() {
    this.isLoading = true;
    try {
      const currentStudent = studentModule.student;
      if (currentStudent && currentStudent.studentID) {
        await studentModule.fetchStudentRecommendationLetters(currentStudent.studentID);
      }
    } catch (error) {
      console.error('推薦書の取得に失敗しました:', error);
    } finally {
      this.isLoading = false;
    }
  }

  handleEdit(letter: RecommendationLetter): void {
    this.selectedLetter = letter;
    this.showModal = true;
  }

  async handleDelete(id: number): Promise<void> {
    this.$Modal.confirm({
      title: this.$t('DELETE_CONFIRMATION').toString(),
      content: this.$t('RECOMMENDATION_LETTER_DELETE_CONFIRM').toString(),
      onOk: async () => {
        try {
          await recommendationLetterModule.deleteRecommendationLetter(id);
          this.$Message.success(this.$t('RECOMMENDATION_LETTER_DELETE_SUCCESS').toString());
        } catch (error) {
          this.$Message.error(this.$t('RECOMMENDATION_LETTER_DELETE_ERROR').toString());
        }
      },
    });
  }

  handleDownload(letter: RecommendationLetter): void {
    const content = letter.content;
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    // 推薦書のupdatedAtをYYYYMMDD_HHMMSS形式にフォーマット
    const updatedAt = new Date(letter.updatedAt);
    const year = updatedAt.getFullYear();
    const month = String(updatedAt.getMonth() + 1).padStart(2, '0');
    const day = String(updatedAt.getDate()).padStart(2, '0');
    const hours = String(updatedAt.getHours()).padStart(2, '0');
    const minutes = String(updatedAt.getMinutes()).padStart(2, '0');
    const seconds = String(updatedAt.getSeconds()).padStart(2, '0');
    const formattedDate = `${year}${month}${day}_${hours}${minutes}${seconds}`;

    a.download = `${letter.title}_${formattedDate}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  }

  async handleLetterUpdated(): Promise<void> {
    // 推薦書リストを再取得（ローディング表示付き）
    await this.fetchRecommendationLetters();
    this.showModal = false;
    this.selectedLetter = null;
  }
}
